export default __webpack_public_path__ + "styles/icons/100mLBottle_green.svg";